import classNames from 'classnames'
import { Link, withPrefix } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import { dayjs } from '../lib/dayjs'
import { pagesPath } from '../lib/pagesPath'
import * as Styles from './news.module.scss'
import { Contact } from '@/components/general/contact'
import { Container } from '@/components/general/container'
import { Layout } from '@/components/general/layout'
import { PageTitle } from '@/components/general/page-title'
import { Seo } from '@/components/general/seo'

export default function News({ pageContext, location }) {
  const {
    nodes,
    category: currentCategory,
    categories,
    // prevPagePath,
    // nextPagePath,
    // pagination,
    // currentPageNum,
    // totalPageNum,
    // totalCount,
  } = pageContext

  return (
    <Layout location={location}>
      <Seo
        title={
          currentCategory ? `お知らせ - ${currentCategory.title}` : 'お知らせ'
        }
        description={
          currentCategory
            ? `Uniforceのお知らせ（${currentCategory.title}）一覧です。決算開示業務を「最短・最適ルート」へと導くというコンセプトのもと、業務全体を見渡しながら正しい順序でナビゲーションし、細かなタスクの抜け漏れを防ぎ、スムーズで快適な業務を遂行することができる業界初のDXソリューションサービスです。`
            : 'Uniforceのお知らせ一覧です。決算開示業務を「最短・最適ルート」へと導くというコンセプトのもと、業務全体を見渡しながら正しい順序でナビゲーションし、細かなタスクの抜け漏れを防ぎ、スムーズで快適な業務を遂行することができる業界初のDXソリューションサービスです。'
        }
      />
      <section className={Styles.news}>
        <PageTitle
          en="INFORMATION"
          title="お知らせ"
          decorationLogo
          isChildHeight={false}
          className={Styles.news__pageTitle}
        >
          <div className={Styles.pageTitle_decoration_1}>
            <StaticImage
              src="../images/page-title_image_news.png"
              height={138.84}
            />
          </div>
        </PageTitle>

        {/* カテゴリー一覧 */}
        <Container>
          <ul className={Styles.news__category_list}>
            <li>
              <Link
                to={pagesPath.news.$url()}
                className={classNames(
                  !currentCategory && Styles.news__category_list__current_anchor
                )}
              >
                ALL
              </Link>
            </li>
            {categories.map((category, i) => (
              <li key={i}>
                <Link
                  to={pagesPath.news._category(category.slug).$url()}
                  className={classNames(
                    currentCategory &&
                      currentCategory.slug === category.slug &&
                      Styles.news__category_list__current_anchor
                  )}
                >
                  {category.title}
                </Link>
              </li>
            ))}
          </ul>

          <ul className={Styles.news__boxwrap}>
            {nodes.map((node) => (
              <li key={node.serviceId} className={Styles.news__box}>
                <p className={Styles.news__category}>{node.category.title}</p>
                <p>{node.title}</p>
                <div className={Styles.news__smalltext}>
                  <p className={Styles.news__date}>
                    {dayjs(node.publishedAt).format('YYYY/MM/DD')}
                  </p>
                  <Link
                    to={pagesPath.news._contentId(node.serviceId).$url()}
                    className={Styles.news__newsbtn}
                  >
                    詳細&emsp;
                    <img src={withPrefix('/news_icon_more.svg')} alt="" />
                  </Link>
                </div>
              </li>
            ))}
          </ul>
        </Container>
      </section>
      <Contact />
    </Layout>
  )
}
